import { CheckCircle } from "lucide-react";

const InfoRow = ({ label, value, verified = false }) => (
  <div className="flex flex-col sm:flex-row justify-between sm:items-center py-2">
    <span className="text-sm font-medium text-secondary-600">{label}</span>
    <div className="flex items-center space-x-2">
      <span className="font-semibold text-secondary-800 text-sm">{value}</span>
      {verified && <CheckCircle className="w-4 h-4 text-green-500" />}
    </div>
  </div>
);

export default InfoRow;